import React from "react";
import { logo } from "../Constant/Index";
import { Link, NavLink } from "react-router-dom";

function Header() {
  return (
    <>
      {/* Top Header  */}
      <section className="top-bar secondary-bg">
        <div className="container">
          <div className="row">
            <div className="col-md-10">
              <div className="top-bar-para text-center">
                <p>Free Shipping on first 1000 customers. Shop Now!</p>
              </div>
            </div>
            <div className="col-md-2">
              <div className="top-drop-down">
                <select name="choice">
                  <option value="first">English</option>
                  <option value="second" selected>
                    French
                  </option>
                  {/* <option value="third">Third Value</option> */}
                </select>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ============= */}

      {/* Bottom Header  */}
      <section className="bottom-header extra-bg-2">
        <div className="container">
          <div className="row">
            <div className="col-md-2">
              <div className="web-logo">
                <Link to="/">
                  <img src={logo} alt="logo-img" className="img-fluid" />
                </Link>
              </div>
            </div>
            <div className="col-md-5">
              <div className="nav-bar">
                <ul>
                  <NavLink to="/">
                    <li>Home</li>
                  </NavLink>
                  <NavLink to="/about-us">
                    <li>About us</li>
                  </NavLink>
                  <NavLink to="/shop">
                    <li>Shop</li>
                  </NavLink>
                  <NavLink to="/blogs">
                    <li>Blogs</li>
                  </NavLink>
                  <NavLink to="/contact-us">
                    <li>Contact us</li>
                  </NavLink>
                </ul>
              </div>
            </div>
            <div className="col-md-2">
              <div className="seacrh-input">
                <input type="text" placeholder="Search" />
                <div className="search-icon">
                  <i class="fa fa-search extra-color-6" aria-hidden="true"></i>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <div className="header-icons-dv">
                <div className="login-icon">
                  <div className="btn-dv">
                    <Link to="/login">
                      <button className="btn-all">login</button>
                    </Link>
                  </div>
                </div>
                <Link to="/cart">
                  <div className="basket-icon b-icon-one">
                    <i class="fa fa-shopping-basket" aria-hidden="true"></i>
                    <span>1</span>
                  </div>
                </Link>

                <Link to="/wishlist">
                  <div className="basket-icon">
                    <i class="fa fa-heart" aria-hidden="true"></i>
                    <span>1</span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* =============== */}
    </>
  );
}
export default Header;
